import React from 'react';
import { motion } from 'framer-motion';

const TrustedBySection = () => {
  const logos = [
    { type: 'image', src: '/assets/practicelogos/advanceddentalhealth.png', alt: 'Advanced Dental Health' },
    { type: 'image', src: '/assets/practicelogos/image 1.png', alt: 'Alpha Dental Excellence', className: 'h-8 md:h-10' },
    { type: 'image', src: '/assets/practicelogos/image 2.png', alt: 'Dental Practice 2' },
    { type: 'image', src: '/assets/practicelogos/image 3.png', alt: 'Dental Practice 3' },
    { type: 'image', src: '/assets/practicelogos/image 4.png', alt: 'Dental Practice 4' },
    { type: 'image', src: '/assets/practicelogos/image 5.png', alt: 'Dental Practice 5' },
    { type: 'text', text: 'Rowland Family Dentistry', subtext: 'EST. 1998', style: 'serif' },
  ];

  return (
    <section className="py-14 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-8 text-center">
        <p className="text-sm font-semibold text-gray-400 uppercase tracking-widest">
          Trusted by Dental Offices Across the Country
        </p>
      </div>
      
      <div className="relative w-full overflow-hidden">
        <div className="absolute left-0 top-0 bottom-0 w-32 z-10 bg-gradient-to-r from-white to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 z-10 bg-gradient-to-l from-white to-transparent pointer-events-none" />

        <div className="flex">
          <motion.div 
            className="flex items-center space-x-20 whitespace-nowrap"
            animate={{ x: ["0%", "-50%"] }}
            transition={{ repeat: Infinity, ease: "linear", duration: 40 }}
          >
            {[...logos, ...logos].map((logo, index) => (
              <div key={index} className="flex-shrink-0 grayscale hover:grayscale-0 transition-all duration-300 opacity-50 hover:opacity-100 flex items-center justify-center h-14">
                {logo.type === 'text' ? (
                  <div className={`flex flex-col items-center justify-center px-4 ${logo.style === 'serif' ? 'font-serif' : 'font-sans'}`}>
                    <span className="text-lg font-bold text-gray-700 tracking-tight leading-none">{logo.text}</span>
                    {logo.subtext && <span className="text-[9px] tracking-[0.2em] text-gray-400 font-sans mt-1">{logo.subtext}</span>}
                  </div>
                ) : (
                  <img src={logo.src} alt={logo.alt} className={`${logo.className || "h-10 md:h-14"} w-auto object-contain max-w-[180px]`} />
                )}
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TrustedBySection;
